import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./components/authentication/LoginPage";
import HomePage from "./components/homepage/HomePage";
import ProtectedRoute from "./components/authentication/ProtectedRoute";
import RegisterPage from "./components/authentication/RegisterPage";
import { RecoilRoot } from "recoil";
import Attendance from "./components/attendance/Attendance";
import NotFound from "./components/common/NotFound";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Salary from "./components/salary/Salary";
import InventoryDashboard from "./components/inventory/InventoryDashboard";
import InOutDashboard from "./components/inventory/InOutDashboard";
import { AuthProvider } from "./context/AuthProvider";
import { HasRole } from "./context/HasRole";
import IncomingItemsDashboard from "./components/incoming-items/IncomingItemsDashboard";
import InventoryReportsDashboard from "./components/inventory-reports/InventoryReportsDashboard";
import PendingBarcodesReports from "./components/inventory-reports/PendingBarcodesReport";
import Costing from "./components/costing/Costing";
import ToolDevelopment from "./components/tooling/ToolDevelopment";
import Todos from "./components/todos/Todos";

const queryClient = new QueryClient();

function App() {
  return (
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <AuthProvider>
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              </AuthProvider>
            }
          >
            <Route index element={<Navigate to="/todos" replace />} />
            <Route path="/todos" element={<Todos />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/inventory" element={<InventoryDashboard />}></Route>
            <Route path="/tool-development" element={<ToolDevelopment />} />
            <Route
              path="/inventory-reports"
              element={<InventoryReportsDashboard />}
            >
              <Route
                index
                element={<Navigate to="pending-barcodes" replace />}
              />
              <Route
                path="pending-barcodes"
                element={<PendingBarcodesReports />}
              />
              <Route
                path="stock-summary"
                element={<div>Stock Summary Report</div>}
              />
            </Route>
            <Route path="/in-out" element={<InOutDashboard />}></Route>
            <Route
              path="/incoming-items"
              element={<IncomingItemsDashboard />}
            ></Route>
            <Route path="/orders"></Route>
            <Route
              path="/attendance"
              element={
                <HasRole roles={["admin", "accounts"]}>
                  <Attendance />
                </HasRole>
              }
            ></Route>
            <Route
              path="/salary"
              element={
                <HasRole roles={["admin", "accounts"]}>
                  <Salary />
                </HasRole>
              }
            ></Route>
            <Route
              path="/costing"
              element={
                <HasRole roles={["admin"]}>
                  <Costing />
                </HasRole>
              }
            ></Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </RecoilRoot>
  );
}

export default App;
